export const SET_ENGINEERS              = 'SET_ENGINEERS';
export const SET_ENGINEERS_LOADING      = 'SET_ENGINEERS_LOADING';
export const SET_ENGINEERS_ERROR        = 'SET_ENGINEERS_ERROR';
export const CLEAR_ENGINEERS            = 'CLEAR_ENGINEERS';
export const CLEAR_ENGINEERS_ERROR      = 'CLEAR_ENGINEERS_ERROR';
export const SET_SCHEDULER_DEPARTMENT   = 'SET_SCHEDULER_DEPARTMENT';
export const CLEAR_SCHEDULER_DEPARTMENT = 'CLEAR_SCHEDULER_DEPARTMENT';
